
// import React, { useEffect , useState, useRef } from 'react'
// import SendInput from './SendInput'
// import Messages from './Messages';
// import { useSelector, useDispatch } from "react-redux";
// import { setSelectedUser, incrementUnreadCount, updateLastMessageTimestamp, updateLastMessageContent } from '../redux/userSlice';
// import { setMessages, addNewMessage } from '../redux/messageSlice';
// import { deleteMessage as deleteMessageAction } from '../redux/messageSlice';
// import axios from 'axios';
// import { BASE_URL } from '../config';
// import useGetRealTimeMessage from '../hooks/useGetRealTimeMessage';
// import InstallButton from './InstallButton';
// import { IoArrowBack } from 'react-icons/io5'; // Added missing import
// import useWindowSize from '../hooks/useWindowSize'; 
// import AnnouncementBanner from './AnnouncementBanner';

// const MessageContainer = () => {
//     const { selectedUser, authUser, onlineUsers ,adminId} = useSelector(store => store.user);
//     const { messages } = useSelector(store => store.message);
//     const { socket } = useSelector(store => store.socket);
//     const dispatch = useDispatch();
//     const [isTyping, setIsTyping] = useState(false);
//     const [typingUser, setTypingUser] = useState('');
//     const typingTimeout = useRef(null);
//        const messagesContainerRef = useRef(null);
//            const { width } = useWindowSize(); // Get window size
//     const isMobile = width < 768; 


//     // Use the real-time message hook
//     useGetRealTimeMessage();
    
//      // Add the heartbeat useEffect properly (not conditionally)
//      useEffect(() => {
//         if (!socket || !authUser) return;

//         // Set up heartbeat interval
//         const heartbeatInterval = setInterval(() => {
//             if (socket.connected) {
//                 socket.emit('heartbeat');
//             }
//         }, 25000); // 25 seconds

//         return () => {
//             clearInterval(heartbeatInterval);
//         };
//     }, [socket, authUser]); // Add dependencies

   
//     useEffect(() => {
//         if (!socket) return;
    
//         const handleMessageDeleted = ({ messageId }) => {
//             dispatch(deleteMessageAction(messageId));
//         };
    
//         socket.on('messageDeleted', handleMessageDeleted);
//         return () => socket.off('messageDeleted', handleMessageDeleted);
//     }, [socket, dispatch]);

//     // In MessageContainer.js - Update the useEffect for typing events
// useEffect(() => {
//     if (!socket || !selectedUser) return;

//     const handleTypingEvent = ({ senderId, nickname }) => {
//         // For regular users: Show typing for any admin message
//         if (authUser?.isRole !== 1) {
//             setIsTyping(true);
//             setTypingUser(nickname || "Support Agent");
//             clearTimeout(typingTimeout.current);
//             typingTimeout.current = setTimeout(() => setIsTyping(false), 5000);
//         }
//         // For admins: Show typing only for selected user
//         else if (senderId === selectedUser?._id) {
//             setIsTyping(true);
//             setTypingUser(nickname || "User");
//             clearTimeout(typingTimeout.current);
//             typingTimeout.current = setTimeout(() => setIsTyping(false), 3000);
//         }
//     };

//     const handleStopTypingEvent = ({ senderId }) => {
//         if (authUser?.isRole !== 1 || senderId === selectedUser?._id) {
//             setIsTyping(false);
//             clearTimeout(typingTimeout.current);
//         }
//     };

//     socket.on('typing', handleTypingEvent);
//     socket.on('stopTyping', handleStopTypingEvent);

//     return () => {
//         socket.off('typing', handleTypingEvent);
//         socket.off('stopTyping', handleStopTypingEvent);
//         clearTimeout(typingTimeout.current);
//     };
// }, [socket, selectedUser, authUser]);
   
// useEffect(() => {

//     //   if (authUser?.isRole === 1) {
//     //     dispatch(setSelectedUser(null));
//     //     return;
//     // }

//      if (authUser?.isRole === 1) return;
  
//     const savedUser = localStorage.getItem('selectedUser');
//     if (savedUser) {
//         dispatch(setSelectedUser(JSON.parse(savedUser)));
//         return;
//     }

//     if (authUser && (authUser.isGuest || authUser.isRole !== 1)) {
//         const virtualAdmin = {
//             _id: 'admins',
//             username: 'Support Team',
//         };
//         dispatch(setSelectedUser(virtualAdmin));
//         localStorage.setItem('selectedUser', JSON.stringify(virtualAdmin));
//     }
// }, [authUser, dispatch]);

//     // const isOnline = onlineUsers?.includes(selectedUser?._id);
//     const isOnline = authUser?.isRole !== 1 && selectedUser?._id === 'admins' 
//     ? true  // Always show online for admins when viewed by regular users
//     : onlineUsers?.includes(selectedUser?._id);  // Normal check for others
   

//     if (authUser?.isRole === 1 && !selectedUser) {
//         return (
//             <div className='flex flex-col flex-grow w-full h-screen bg-[#efeae2] items-center justify-center'>
//                 <div className='text-center p-6'>
//                     <h2 className='text-xl font-semibold mb-2'>Select a user</h2>
//                     <p className='text-gray-600'>Choose a user from the sidebar to start chatting</p>
//                 </div>
//             </div>
//         );              
//     }


//     return (
//             //   <div className='flex flex-col flex-grow w-full h-screen bg-[#efeae2]'>
//             <div className='flex flex-col w-full h-[100dvh] bg-[#efeae2] relative'>
//             <div className='flex justify-between items-center bg-[#f0f2f5] text-black px-4 py-2 sticky top-0 z-10'>
//                  <div className='flex items-center flex-1'>
//                   {isMobile && authUser?.isRole === 1 && (
//     <button 
//       onClick={() => dispatch(setSelectedUser(null))}
//       className="p-1 mr-0"
//     >
//       <IoArrowBack size={24} />
//     </button>
//   )}
//               <div className="flex items-center">
//                 <div className={`avatar ${isOnline ? 'online' : ''}`}>
//                     <div className='w-12 rounded-full'>
                       
//                     </div>
//                 </div>
//                 <div className='flex flex-col ml-2'>
                  
//                         <p>
//                             {authUser?.isRole === 1 
//                                 ? (selectedUser?.username || "Select a user") 
//                                 : "Onexgames Support"
//                             }
//                         </p>
//                         <span className={`text-xs ${isOnline ? 'text-green-500' : 'text-gray-500'}`}>
//                             {isOnline ? 'Online' : 'Offline'}
//                         </span>
//                     </div>
//                 </div>
//                   </div>
                   
//                 {authUser?.isRole === 1 && selectedUser && (
//                     <div className="text-right text-sm space-y-1 pr-2">
//                         {selectedUser.email && (
//                             <p className="truncate max-w-[120px] md:max-w-[200px]">
//                                 {selectedUser.email}
//                             </p>
//                         )}
//                         {selectedUser.mobileNumber && (
//                             <p className="text-gray-600">
//                                 {selectedUser.mobileNumber}
//                             </p>
//                         )}
//                     </div>
//                 )}
//             </div>
             

//                    <div className="fixed top-4 right-4 z-50">
//                        {authUser?.isRole !== 1 && <InstallButton />}
//                        </div>

//                       <AnnouncementBanner />
                   
//              <div
//             //  className='flex-1 overflow-auto pb-24 md:pb-0 relative'
//                className='flex-1 overflow-y-auto pb-16' 
//                 ref={messagesContainerRef}
//                 style={{
//                     WebkitOverflowScrolling: 'touch', // for smooth scrolling on iOS
//                 }}
            
//             >
//                 <Messages />

//             </div>

//             {/* {isTyping && (
//                 <div className="px-4 pb-1">
//                      <div className="bg-gray-100 border-x border-t border-gray-200 rounded-t-lg px-4 py-2">
//                     <div className="text-sm text-black italic animate-pulse">
//                         {typingUser} <b>is typing...</b>
//                     </div>
//                     </div>
//                 </div>
//             )} */}

// {isTyping && (
//     <div className="absolute bottom-16 left-0 right-0">
//         <div className="bg-gray-100 border-t border-gray-200 rounded-t-lg px-3 py-1.5 shadow-sm">
//             <div className="text-sm text-black ">
//                 {typingUser} <b>is typing...</b>
//             </div>
//         </div>
//     </div>
// )}


//             <div className='sticky bottom-0 bg-white border-t border-gray-200 md:static w-full'>
//             {(authUser?.isRole === 1 ? selectedUser : true) && <SendInput />}
//             </div>
//         </div>
//     );
// }

// export default MessageContainer; 




import React, { useEffect , useState, useRef } from 'react'
import SendInput from './SendInput'
import Messages from './Messages';
import { useSelector, useDispatch } from "react-redux";
import { setSelectedUser, incrementUnreadCount, updateLastMessageTimestamp, updateLastMessageContent } from '../redux/userSlice';
import { setMessages, addNewMessage } from '../redux/messageSlice';
import { deleteMessage as deleteMessageAction } from '../redux/messageSlice';
import axios from 'axios';
import { BASE_URL } from '../config';
import useGetRealTimeMessage from '../hooks/useGetRealTimeMessage';
import InstallButton from './InstallButton';
import { IoArrowBack } from 'react-icons/io5';
import { FiCopy, FiCheck } from 'react-icons/fi'; // Added check icon
import useWindowSize from '../hooks/useWindowSize'; 
import AnnouncementBanner from './AnnouncementBanner';
import { useNavigate, useLocation } from 'react-router-dom';


const MessageContainer = () => {
    const { selectedUser, authUser, onlineUsers ,adminId} = useSelector(store => store.user);
    const { messages } = useSelector(store => store.message);
    const { socket } = useSelector(store => store.socket);
    const dispatch = useDispatch();
    const [isTyping, setIsTyping] = useState(false);
    const [typingUser, setTypingUser] = useState('');
    const [copiedField, setCopiedField] = useState(null); // Track which field was copied
    const typingTimeout = useRef(null);
    const messagesContainerRef = useRef(null);
    const { width } = useWindowSize();
    const isMobile = width < 768;
    const copyFeedbackTimeout = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();


    // Copy to clipboard function
    const copyToClipboard = (text, field) => {
        navigator.clipboard.writeText(text);
        setCopiedField(field);
        
        // Clear any existing timeout and set new one
        clearTimeout(copyFeedbackTimeout.current);
        copyFeedbackTimeout.current = setTimeout(() => {
            setCopiedField(null);
        }, 2000);
    };

    // Prevent default context menu on mobile for elements we want to handle copying
    useEffect(() => {
        const handleContextMenu = (e) => {
            if (isMobile && (e.target.closest('.copyable-field'))) {
                e.preventDefault();
            }
        };

        document.addEventListener('contextmenu', handleContextMenu);
        return () => document.removeEventListener('contextmenu', handleContextMenu);
    }, [isMobile]);

    // Clear timeout on unmount
    useEffect(() => {
        return () => {
            clearTimeout(copyFeedbackTimeout.current);
            clearTimeout(typingTimeout.current);
        };
    }, []);

    // Use the real-time message hook
    useGetRealTimeMessage();
    
    // Add the heartbeat useEffect properly (not conditionally)
    useEffect(() => {
        if (!socket || !authUser) return;

        // Set up heartbeat interval
        const heartbeatInterval = setInterval(() => {
            if (socket.connected) {
                socket.emit('heartbeat');
            }
        }, 25000); // 25 seconds

        return () => {
            clearInterval(heartbeatInterval);
        };
    }, [socket, authUser]);

    useEffect(() => {
        if (!socket) return;
    
        const handleMessageDeleted = ({ messageId }) => {
            dispatch(deleteMessageAction(messageId));
        };
    
        socket.on('messageDeleted', handleMessageDeleted);
        return () => socket.off('messageDeleted', handleMessageDeleted);
    }, [socket, dispatch]);

    // Handle hardware back button on mobile for admin view
useEffect(() => {
    if (!isMobile || authUser?.isRole !== 1 || !selectedUser) return;

    const handlePopState = () => {
        dispatch(setSelectedUser(null));
    };

    window.addEventListener('popstate', handlePopState);

    // Push current state to history so back button works
    window.history.pushState({}, '');

    return () => {
        window.removeEventListener('popstate', handlePopState);
    };
}, [isMobile, authUser, selectedUser, dispatch]);


    useEffect(() => {
        if (!socket || !selectedUser) return;

        const handleTypingEvent = ({ senderId, nickname }) => {
            if (authUser?.isRole !== 1) {
                setIsTyping(true);
                setTypingUser(nickname || "Support Agent");
                clearTimeout(typingTimeout.current);
                typingTimeout.current = setTimeout(() => setIsTyping(false), 5000);
            }
            else if (senderId === selectedUser?._id) {
                setIsTyping(true);
                setTypingUser(nickname || "User");
                clearTimeout(typingTimeout.current);
                typingTimeout.current = setTimeout(() => setIsTyping(false), 3000);
            }
        };

        const handleStopTypingEvent = ({ senderId }) => {
            if (authUser?.isRole !== 1 || senderId === selectedUser?._id) {
                setIsTyping(false);
                clearTimeout(typingTimeout.current);
            }
        };

        socket.on('typing', handleTypingEvent);
        socket.on('stopTyping', handleStopTypingEvent);

        return () => {
            socket.off('typing', handleTypingEvent);
            socket.off('stopTyping', handleStopTypingEvent);
            clearTimeout(typingTimeout.current);
        };
    }, [socket, selectedUser, authUser]);
   
    useEffect(() => {
        if (authUser?.isRole === 1) return;
  
        const savedUser = localStorage.getItem('selectedUser');
        if (savedUser) {
            dispatch(setSelectedUser(JSON.parse(savedUser)));
            return;
        }

        if (authUser && (authUser.isGuest || authUser.isRole !== 1)) {
            const virtualAdmin = {
                _id: 'admins',
                username: 'Support Team',
            };
            dispatch(setSelectedUser(virtualAdmin));
            localStorage.setItem('selectedUser', JSON.stringify(virtualAdmin));
        }
    }, [authUser, dispatch]);

    const isOnline = authUser?.isRole !== 1 && selectedUser?._id === 'admins' 
        ? true
        : onlineUsers?.includes(selectedUser?._id);

    if (authUser?.isRole === 1 && !selectedUser) {
        return (
            <div className='flex flex-col flex-grow w-full h-screen bg-[#efeae2] items-center justify-center'>
                <div className='text-center p-6'>
                    <h2 className='text-xl font-semibold mb-2'>Select a user</h2>
                    <p className='text-gray-600'>Choose a user from the sidebar to start chatting</p>
                </div>
            </div>
        );              
    }

    return (
        <div className='flex flex-col w-full h-[100dvh] bg-[#efeae2] relative select-none'
           style={{
        userSelect: 'none',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none'
    }}
        >
            <div className='flex justify-between items-center bg-[#f0f2f5] text-black px-4 py-2 sticky top-0 z-10'>
                <div className='flex items-center flex-1'>
                    {isMobile && authUser?.isRole === 1 && (
                        <button 
                            onClick={() => dispatch(setSelectedUser(null))}
                            className="p-0.5 mr-0"
                        >
                            <IoArrowBack size={24} />
                        </button>
                    )}
                    <div className="flex items-center">
                        <div className={`avatar ${isOnline ? 'online' : ''} hidden md:block`}>
                            <div className='w-12 rounded-full'></div>
                        </div>
                        <div className='flex flex-col ml-2'>
                            <p>
                                {authUser?.isRole === 1 
                                    ? (selectedUser?.username || "Select a user") 
                                    : "Onexgames Support"
                                }
                            </p>
                            <span className={`text-xs ${isOnline ? 'text-green-500' : 'text-gray-500'}`}>
                                {isOnline ? 'Online' : 'Offline'}
                            </span>
                        </div>
                    </div>
                </div>
                   
                {authUser?.isRole === 1 && selectedUser && (
                    <div className="text-right text-sm space-y-1 pr-2">
                        {selectedUser.email && (
                            <div 
                                className="copyable-field relative group"
                                onClick={() => isMobile && copyToClipboard(selectedUser.email, 'email')}
                                  style={{
                                        userSelect: 'none',
                                        WebkitUserSelect: 'none'
                                   }}
                            >
                                <p className="truncate max-w-[120px] md:max-w-[200px] inline-flex items-center group-hover:bg-gray-100 rounded px-1 text-xs">
                                    {selectedUser.email}
                                    {!isMobile && (
                                        <button 
                                            // onClick={() => copyToClipboard(selectedUser.email, 'email')}
                                             onClick={(e) => {
                                                    e.stopPropagation();
                                                    copyToClipboard(selectedUser.email, 'email');
                                               }}
                                            className="ml-1 text-gray-500 hover:text-gray-700 opacity-0 group-hover:opacity-100 transition-opacity"
                                            aria-label="Copy email"
                                        >
                                            {copiedField === 'email' ? (
                                                <FiCheck size={14} className="text-green-500" />
                                            ) : (
                                                <FiCopy size={14} />
                                            )}
                                        </button>
                                    )}
                                </p>
                            </div>
                        )}
                        {selectedUser.mobileNumber && (
                            <div 
                                className="copyable-field relative group"
                                onClick={() => isMobile && copyToClipboard(selectedUser.mobileNumber, 'mobile')}
                                  style={{
                                    userSelect: 'none',
                                    WebkitUserSelect: 'none'
                                }}
                            >
                                <p className="text-gray-600 inline-flex items-center group-hover:bg-gray-100 rounded px-1 text-xs">
                                    {selectedUser.mobileNumber}
                                    {!isMobile && (
                                        <button 
                                            // onClick={() => copyToClipboard(selectedUser.mobileNumber, 'mobile')}
                                             onClick={(e) => {
                                                e.stopPropagation();
                                                copyToClipboard(selectedUser.mobileNumber, 'mobile');
                                            }}
                                            className="ml-1 text-gray-500 hover:text-gray-700 opacity-0 group-hover:opacity-100 transition-opacity"
                                            aria-label="Copy mobile number"
                                        >
                                            {copiedField === 'mobile' ? (
                                                <FiCheck size={14} className="text-green-500" />
                                            ) : (
                                                <FiCopy size={14} />
                                            )}
                                        </button>
                                    )}
                                </p>
                            </div>
                        )}
                    </div>
                )}
            </div>
             
            <div className="fixed top-4 right-4 z-50">
                {authUser?.isRole !== 1 && <InstallButton />}
            </div>

            <AnnouncementBanner />
                   
            <div
                className='flex-1 overflow-y-auto pb-16' 
                ref={messagesContainerRef}
                style={{
                    WebkitOverflowScrolling: 'touch',
                }}
            >
                <Messages />
            </div>

            {isTyping && (
                <div className="absolute bottom-16 left-0 right-0">
                    <div className="bg-gray-100 border-t border-gray-200 rounded-t-lg px-3 py-1.5 shadow-sm">
                        <div className="text-sm text-black ">
                            {typingUser} <b>is typing...</b>
                        </div>
                    </div>
                </div>
            )}

            <div className='sticky bottom-0 bg-white border-t border-gray-200 md:static w-full'>
                {(authUser?.isRole === 1 ? selectedUser : true) && <SendInput />}
            </div>
        </div>
    );
}

export default MessageContainer;